import { useEffect } from 'react';
import { useLocation } from 'ice';

// 自定义钩子
const useScrollToTop = () => {
    // 获取当前的location对象
    const location = useLocation();


    useEffect(() => {
        document.querySelector('#scroll')?.scrollTo({ top: 0 });
    }, [location]); // 依赖项为location，只有当location变化时才执行
};

export default useScrollToTop;
